import { useEffect } from 'react'

import {
  actionsSelector,
  paramsSelector,
  redirectUrlSelector,
  useStore,
} from '@liveHelper/models/store'

import { navigateTo } from '@core/helpers/navigateTo'
import { getPIPIframe } from '@core/pictureInPicture/getPIPIframe'
import { TargetEnum, usePIPTarget } from '@core/pictureInPicture/usePIPTarget'

/**
 * Hook to redirect to the URL with PIP target behavior
 */
export const useRedirectUrl = () => {
  const params = useStore(paramsSelector)
  const href = useStore(redirectUrlSelector)
  const { setRedirectUrl } = useStore(actionsSelector)

  const { url, target, onClick } = usePIPTarget({
    url: href,
    params: params,
  })

  const pipIframe = getPIPIframe()

  useEffect(() => {
    if (href) {
      if (url && pipIframe) {
        const link = pipIframe.document.createElement('a')
        link.href = url
        link.target = TargetEnum.PIP_IFRAME
        link.onclick = () => onClick()
        link.click()

        setRedirectUrl('')
        link.remove()
      } else {
        navigateTo(href)
      }
    }
  }, [href, onClick, pipIframe, setRedirectUrl, target, url])
}
